import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faCloudArrowUp,
  faCubes,
  faListCheck,
  faTable,
} from "@awesome.me/kit-70c1f0055f/icons/duotone/solid";
import { getFileIconVisual } from "@/utils/files";

/** Tailwind classes for the kind icon container. */
export type ArtifactKindTone = {
  bg: string;
  text: string;
};

export type ArtifactKindVisual = {
  icon: IconDefinition;
  tone: ArtifactKindTone;
};

/**
 * Icon for an artifact: file MIME/extension first (see ``@/utils/files``),
 * then structural ``artifact.kind`` (table / form / upload). ``null`` if unknown.
 */
export function artifactIconVisual(
  kind: string,
  mimeType?: string | null,
  filename?: string | null,
): ArtifactKindVisual | null {
  const fileVisual = getFileIconVisual(mimeType, filename);
  if (fileVisual) {
    return { icon: fileVisual.icon, tone: fileVisual.tone };
  }
  return artifactKindVisual(kind);
}

/** Icon + colour for structural artifact kinds (not file MIME/extension). */
export function artifactKindVisual(kind: string): ArtifactKindVisual | null {
  if (kind === "table") {
    return {
      icon: faTable,
      tone: {
        bg: "bg-sky-500/10",
        text: "text-sky-700 dark:text-sky-300",
      },
    };
  }
  if (kind === "form") {
    return {
      icon: faCubes,
      tone: {
        bg: "bg-amber-500/10",
        text: "text-amber-700 dark:text-amber-300",
      },
    };
  }
  if (kind === "checklist") {
    return {
      icon: faListCheck,
      tone: {
        bg: "bg-emerald-500/10",
        text: "text-emerald-700 dark:text-emerald-300",
      },
    };
  }
  if (kind === "user_upload") {
    return {
      icon: faCloudArrowUp,
      tone: {
        bg: "bg-violet-500/10",
        text: "text-violet-700 dark:text-violet-300",
      },
    };
  }
  return null;
}
